<div class="list-page list-page--wide">
  <header class="page-header">
    <h1 class="page-header__title">History</h1>
    <p class="page-header__subtitle">Your completed and closed projects.</p>
  </header>

  <div *ngIf="data?.length > 0; else placeholder">
    <ng-container *ngFor="let item of data; trackBy: trackByProjectId">
      <app-project-group
        [project]="item"
        [type]="'project-history'"
        [readOnly]="true"
        [testIdProjectScope]="item.projectId"
      ></app-project-group>
    </ng-container>
  </div>
  <ng-template #placeholder>
    <div *ngIf="loading; else notLoading" class="empty-state" data-testid="project-history-loading">
      <p class="empty-state__title">Loading completed projects…</p>
    </div>
    <ng-template #notLoading>
      <div class="empty-state" data-testid="project-history-empty">
        <p class="empty-state__title">No completed projects</p>
        <p class="empty-state__text">Projects you've completed will appear here.</p>
      </div>
    </ng-template>
  </ng-template>
</div>
